import { render, staticRenderFns } from "./commonIconBtn.vue?vue&type=template&id=a0dbe6d0&scoped=true"
import script from "./commonIconBtn.vue?vue&type=script&lang=ts"
export * from "./commonIconBtn.vue?vue&type=script&lang=ts"
import style0 from "./commonIconBtn.vue?vue&type=style&index=0&id=a0dbe6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dbe6d0",
  null
  
)

export default component.exports